var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "fill-height max-width pa-1 ma-0",
      class: _vm.col != 1 ? "" : "",
    },
    [
      _vm.col == 1
        ? _c(
            "v-card",
            {
              staticClass:
                "\n      pa-0\n      fill-height\n      d-flex\n      align-start\n      flex-column\n      justify-space-between\n      flex-grow-1\n      align-self-start\n    ",
              attrs: { elevation: 0, tile: "" },
            },
            [
              _c(
                "v-card-text",
                {
                  staticClass:
                    "\n        white\n        max-width\n        fill-height\n        pa-0\n        d-flex\n        transparent\n        justify-center\n        flex-column\n        pa-0\n        ma-0\n      ",
                },
                [
                  _c(
                    "v-list-item",
                    { staticClass: "grow pa-0 ma-0", attrs: { dense: "" } },
                    [
                      _c(
                        "v-list-item-avatar",
                        { staticClass: "mr-2", attrs: { size: "40" } },
                        [
                          _c("StaffAvatar", {
                            attrs: {
                              size: "40",
                              isTemp: _vm.curData.is_temp,
                              contentClass: "white--text",
                              src: _vm.curData.staff_avatar,
                              staff_name: _vm.curData.preferred_name,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-content",
                        { staticClass: "ma-0 pa-0" },
                        [
                          _c(
                            "v-list-item-title",
                            { staticClass: "text-title text-left table-title" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$getCommonLangValue(
                                    _vm.curData.preferred_name
                                  )
                                ) + " "
                              ),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "text--secondary text-caption-xs",
                                },
                                [_vm._v(" " + _vm._s(_vm.curData.staff_code))]
                              ),
                            ]
                          ),
                          _c(
                            "v-list-item-subtitle",
                            {
                              staticClass:
                                "text-left text--secondary table-subtitle",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$getCommonLangValue(
                                      _vm.curData.job_post_name
                                        ? _vm.curData.job_post_name
                                        : ""
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm.col !== 1 && _vm.curShift
        ? _c(
            "v-card",
            {
              staticClass:
                "\n      pa-0\n      rounded-lg\n      max-width\n      shift-content\n      fill-height\n      d-flex\n      align-center\n      flex-column\n      justify-space-between\n      flex-grow-1\n      align-self-center\n    ",
              style: {
                background:
                  _vm.curShift.shift_uuid !== ""
                    ? _vm.curShift.shift_color_code
                    : "white",
              },
              attrs: { elevation: 0, tile: "" },
              on: {
                click: function ($event) {
                  _vm.iSEdited ? _vm.onTriger() : null
                },
              },
            },
            [
              _vm.curShift["ess_att_attendance_master"]
                ? _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: Number(
                          _vm.curShift["ess_att_attendance_master"][
                            "is_holiday"
                          ]
                        ),
                        expression:
                          "Number(curShift['ess_att_attendance_master']['is_holiday'])",
                      },
                    ],
                    staticClass: "swrap-bg fill-height max-width rounded-lg",
                  })
                : _vm._e(),
              _c(
                "v-card-text",
                {
                  staticClass:
                    "\n        pa-0\n        fill-height\n        d-flex\n        transparent\n        flex-column\n        justify-space-between\n        rounded-lg\n      ",
                  style: {
                    zIndex: 3,
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "\n          transparent\n          max-width\n          pa-0\n          d-flex\n          flex-row\n          justify-space-between\n        ",
                      staticStyle: { height: "22px", overflow: "hidden" },
                    },
                    [
                      _c("div", { staticClass: "text-left" }, [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: Number(_vm.curShift.is_locked),
                                expression: "Number(curShift.is_locked)",
                              },
                            ],
                            staticClass: "material-icons-round md-18 pl-1 pt-1",
                          },
                          [_vm._v("not_interested")]
                        ),
                      ]),
                      _c("v-spacer"),
                      _c(
                        "div",
                        { staticClass: "text-right" },
                        [
                          _vm.curShift.remarks !== undefined &&
                          _vm.curShift.remarks !== null &&
                          _vm.curShift.remarks !== ""
                            ? _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              "span",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass:
                                                      "material-icons-round red--text md-12",
                                                  },
                                                  "span",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [_vm._v("fiber_manual_record")]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    114198630
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.curShift.remarks)),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-sheet",
                    {
                      staticClass:
                        "\n          transparent\n          max-width\n          pa-0\n          text-center\n          align-center\n          d-flex\n          flex-column\n          justify-center\n        ",
                      style: {
                        height: "40px",
                      },
                    },
                    [
                      _vm.curShift["ess_att_attendance_master"]
                        ? _c(
                            "v-sheet",
                            {
                              staticClass:
                                "\n            transparent\n            max-width\n            pa-0\n            text-center\n            d-flex\n            align-center align-self-center\n          ",
                              attrs: { height: "20", "max-height": "22" },
                            },
                            [
                              _c(
                                "div",
                                { style: { flex: 1, width: 0 } },
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  "div",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass:
                                                          "text-ellipsis-1 px-1 font-weight-bold",
                                                      },
                                                      "div",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm._f("getText")(
                                                            _vm.curShift[
                                                              "ess_att_attendance_master"
                                                            ],
                                                            _vm.curShift,
                                                            _vm.getText
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        607270842
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("getText")(
                                                _vm.curShift[
                                                  "ess_att_attendance_master"
                                                ],
                                                _vm.curShift,
                                                _vm.getText
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        : _c(
                            "v-sheet",
                            {
                              staticClass:
                                "\n            transparent\n            max-width\n            pa-0\n            d-flex\n            text-center\n            align-center align-self-center\n          ",
                              attrs: { height: "20", "max-height": "22" },
                            },
                            [
                              _vm.curShift["shift_uuid"]
                                ? _c("div", { style: { flex: 1, width: 0 } }, [
                                    _c(
                                      "div",
                                      { staticClass: "text-ellipsis-1 px-1" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.curShift.shift_abbr) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                      _vm.curShift["ess_att_attendance_master"]["site_uuid"]
                        ? _c(
                            "v-sheet",
                            {
                              staticClass:
                                "\n            transparent\n            max-width\n            pa-0\n            d-flex\n            text-center\n            align-center\n            text--secondary\n          ",
                              style: { fontSize: "12px" },
                              attrs: { height: "20", "max-height": "22" },
                            },
                            [
                              _c("div", { style: { flex: 1, width: 0 } }, [
                                _c(
                                  "div",
                                  { staticClass: "text-ellipsis-1 px-1" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$getCommonLangValue(
                                            _vm.curShift[
                                              "ess_att_attendance_master"
                                            ]["site_abbr"]
                                          )
                                        ) + " "
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("v-spacer"),
                  _vm.curShift["ess_att_attendance_master"]
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "\n          transparent\n          max-width\n          pa-0\n          d-flex\n          flex-column\n          justify-end\n          align-end\n        ",
                          style: { height: "26px" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "\n            transparent\n            max-width\n            pa-0\n            d-flex\n            flex-row\n            justify-space-between\n          ",
                              staticStyle: { height: "20px" },
                            },
                            [
                              Number(
                                _vm.curShift["ess_att_attendance_master"][
                                  "is_on_leave"
                                ]
                              ) &&
                              Number(
                                _vm.curShift["ess_att_attendance_master"][
                                  "is_onduty"
                                ]
                              )
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "text-left text--secondary",
                                    },
                                    _vm._l(
                                      _vm.curShift["ess_att_attendance_master"][
                                        "leave_info"
                                      ],
                                      function (item, index) {
                                        return _c(
                                          "span",
                                          { key: "leave" + index },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$getCommonLangValue(
                                                  item["leave_type_abbr"]
                                                )
                                              ) +
                                                _vm._s(
                                                  index <=
                                                    _vm.curShift[
                                                      "ess_att_attendance_master"
                                                    ]["leave_info"].length -
                                                      2
                                                    ? ","
                                                    : ""
                                                )
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                              _c("v-spacer"),
                              Number(
                                _vm.curShift["ess_att_attendance_master"][
                                  "is_holiday"
                                ]
                              )
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  "div",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass:
                                                          "text-right",
                                                      },
                                                      "div",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "material-icons-round md-20 pink--text",
                                                      },
                                                      [_vm._v("star")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        459776156
                                      ),
                                    },
                                    _vm._l(
                                      _vm.curShift["ess_att_attendance_master"][
                                        "holiday_info"
                                      ],
                                      function (item, index) {
                                        return _c(
                                          "span",
                                          { key: "holiday" + index },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$getCommonLangValue(
                                                  item["holiday_abbr"]
                                                ) +
                                                  (index ==
                                                  _vm.curShift[
                                                    "ess_att_attendance_master"
                                                  ]["holiday_info"].length -
                                                    1
                                                    ? ""
                                                    : ",")
                                              )
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("CardLine", {
                            attrs: {
                              Master: _vm.curShift.ess_att_attendance_master,
                              isFuture: _vm.isFuture,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm.col !== 1 && _vm.curShift == null && _vm.curDate !== ""
        ? _c(
            "v-card",
            {
              staticClass:
                "\n      pa-0\n      max-width\n      rounded-lg\n      fill-height\n      d-flex\n      align-center\n      flex-column\n      justify-start\n      flex-grow-1\n      align-self-center\n    ",
              staticStyle: { overflow: "hidden" },
              attrs: { elevation: "0" },
            },
            [
              _c("div", {
                staticClass: "grey lighten-2 max-width pa-0",
                staticStyle: { height: "25px" },
              }),
              _c("v-card-text", {
                staticClass:
                  "\n        grey\n        lighten-2\n        max-width\n        pa-0\n        text-center\n        d-flex\n        align-center\n        justify-center\n      ",
                style: { overflow: "hidden", height: "42px" },
              }),
              _c("div", {
                staticClass: "grey lighten-2 max-width pa-0",
                staticStyle: { height: "25px" },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }